import React from "react";
import useMembership from "@/shared/hooks/useMembership";
import PathPickUsageCard from "@/features/pathpick/components/usage/PathPickUsageCard";
import PathPickUsageExpiredCard from "@/features/pathpick/components/usage/PathPickUsageExpiredCard";

// 사용량 카드 자리 — 무엇이 들어갈지 여기서만 정한다. 등록 신청 내역 페이지(데스크탑)와
// 모바일 사용량 모달이 같은 판정을 공유해야 해서 삼항을 한 곳으로 모았다.
//
// 만료 시에는 usage 응답이 0·미지원으로만 채워져 "0개 / 0개", 티어 "-" 같은 값이
// 오해를 준다. 만료 카드로 갈아타면 카드의 suspense 쿼리도 함께 빠져 만료 사용자는
// usage 요청·대기가 아예 없다.
//
// 로딩 중 분기는 필요 없다 — 이 카드가 놓이는 화면들은 PathPickAccessGuard가
// 회사 정보 확정 후에만 렌더한다.
function PathPickUsageCardSlot() {
  const { expiredStatus } = useMembership();

  return expiredStatus ? (
    <PathPickUsageExpiredCard status={expiredStatus} />
  ) : (
    <PathPickUsageCard />
  );
}

export default PathPickUsageCardSlot;
